import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import './HowItWorks.css';

const HowItWorks = () => {
  const { t } = useLanguage();
  const fallbackSteps = [
    {
      title: 'Choose Your Pooja',
      description: 'Select the type of pooja that suits your needs and occasion'
    },
    {
      title: 'Book & Pay',
      description: 'Complete your booking and make secure payment online'
    },
    {
      title: 'Receive Details',
      description: 'Get confirmation with pooja details and live streaming link'
    }
  ];
  const steps = t('onlinePooja.howItWorks.steps', {}, fallbackSteps);

  return (
    <section className="how-it-works">
      <div className="container">
        <div className="section-header">
          <h2>{t('onlinePooja.howItWorks.title')}</h2>
          <p>{t('onlinePooja.howItWorks.subtitle')}</p>
        </div>
        <div className="steps-container">
          {steps.map((step, index) => (
            <motion.div
              key={`${index}-${step.title}`}
              className="step"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <motion.div 
                className="step-number"
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.3 }}
              >
                {index + 1}
              </motion.div>
              <div className="step-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;















